import { RouteConfig } from 'vue-router';
import ConsultaBoletins from '../ConsultaBoletins.vue';

const baseRouterLink = '/boletins';

const ConsultaBoletinsRoutes: RouteConfig[] = [
  {
    path: `${baseRouterLink}/consulta`,
    name: 'consulta-boletins',
    component: ConsultaBoletins,
  },
];

export default ConsultaBoletinsRoutes;
